<div class="flex border-bottom border-top flex-col md:flex-row h-full">
  <div class="left-col relative flex flex-col h-full max-h-full">
    <ip-open-layers
      (detail)="onDetail($event)"
      [formats]="formats$ | async"
      [id]="activeId$ | async"
      [image]="image$ | async"
      [items]="items"
      [pagination]="pagination"
      class="block flex-auto"
    ></ip-open-layers>

    <aipb-inside-loading [loading]="loading$ | async"></aipb-inside-loading>

    @if (items.length > 0) {
      <ip-image-strip (detail)="onDetail($event)" [activeId]="activeId$ | async" [items]="items">
      </ip-image-strip>
    }
  </div>

  <div class="sidebar-panel border-left h-full right-col">
    <mat-tab-group>
      @if (hasReport) {
        <mat-tab label="Přehled">
          <ng-template matTabContent>
            <ip-report [castorUrl]="castorUrl" [coreId]="coreId" [id]="activeId$ | async"></ip-report>
          </ng-template>
        </mat-tab>
      }

      <mat-tab [label]="'catalog.image_preview.tabs.image_download' | transloco">
        <ng-template matTabContent>
          <ip-download
            (refresh)="refresh()"
            [id]="activeId$ | async"
            [imageRaw]="imageRaw$ | async"
            [isDropbox]="isDropbox"
            [resolutionData]="resolutionData$ | async"
          ></ip-download>
        </ng-template>
      </mat-tab>
      @if (hasCrop) {
        <mat-tab [label]="'catalog.image_preview.tabs.crop' | transloco">
          <ng-template matTabContent>
            <ip-crop [formats]="formats$ | async" [id]="activeId$ | async"
              [resolutionData]="resolutionData$ | async" [watermarkPositions]="watermarkPositions$ | async"
            [watermarkSources]="watermarkSources$ | async"></ip-crop>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</div>
